/* eslint-disable @wordpress/dependency-group */
import $ from 'jquery';
import variableProductHasEmptyAttribute from '../helpers/variable-product-has-empty-attribute';
import getWcFragmentsRefreshed from '../helpers/get-wc-fragments-refreshed';

const addToCartVariation = function () {
	// eslint-disable-next-line camelcase
	if (typeof wc_add_to_cart_params === 'undefined') return false;

	$('.single_variation_wrap').on(
		'show_variation',
		function (event, variation) {
			// console.log('variation', variation);
			if (variation.variation_description) {
				$(this).addClass('has-variation-description');
			}
		}
	);

	$('.variations_form').on(
		'woocommerce_variation_has_changed',
		function (event) {
			setTimeout(function () {
				const variationWrapper = $('.woocommerce-variation');
				if (variationWrapper.css('display') === 'none') {
					$('.product-meta-stock-message').text('');
					return;
				}
				const copyStockMessage = $(
					'.woocommerce_stock_extra_msg_var span'
				);
				const copyStockMessageText = copyStockMessage.length
					? copyStockMessage[0].innerText
					: '';
				$('.product-meta-stock-message').text(copyStockMessageText);
			}, 500);
		}
	);

	$(document).on(
		'click',
		'.variations_form .add_to_cart_button',
		function (e) {
			e.preventDefault();

			const $variation_form = $(this).closest('.variations_form');

			const var_id = $variation_form
				.find('input[name=variation_id]')
				.val();
			const product_id = $variation_form
				.find('input[name=product_id]')
				.val();
			const quantity = $variation_form.find('input[name=quantity]').val();

			//attributes = [];
			$('.ajaxerrors').remove();
			let item = {},
				check = true;

			let variations = $variation_form.find('select[name^=attribute]');

			/* Updated code to work with radio button - mantish - WC Variations Radio Buttons - 8manos */
			if (!variations.length) {
				variations = $variation_form.find('[name^=attribute]:checked');
			}

			/* Backup Code for getting input variable */
			if (!variations.length) {
				variations = $variation_form.find('input[name^=attribute]');
			}

			variations.each(function () {
				let $this = $(this),
					attributeName = $this.attr('name'),
					attributevalue = $this.val(),
					index,
					attributeTaxName;

				$this.removeClass('error');

				if (attributevalue.length === 0) {
					index = attributeName.lastIndexOf('_');
					attributeTaxName = attributeName.substring(index + 1);

					$this
						.addClass('required error')
						.before(
							'<div class="ajaxerrors"><p>Please select ' +
								attributeTaxName +
								'</p></div>'
						);

					check = false;
				} else {
					item[attributeName] = attributevalue;
				}
			});

			if (!check) {
				return false;
			}

			const $thisbutton = $(this);

			if ($thisbutton.is('.variations_form .add_to_cart_button')) {
				$thisbutton.removeClass('added');
				$thisbutton.addClass('loading');

				const data = {
					action: 'add_to_cart_variable_product',
				};

				$variation_form.serializeArray().map(function (attr) {
					if (attr.name !== 'add-to-cart') {
						if (attr.name.endsWith('[]')) {
							const name = attr.name.substring(
								0,
								attr.name.length - 2
							);
							if (!(name in data)) {
								data[name] = [];
							}
							data[name].push(attr.value);
						} else {
							data[attr.name] = attr.value;
						}
					}
				});

				// Trigger event
				$('body').trigger('adding_to_cart', [$thisbutton, data]);

				// Ajax action
				$.post(
					wc_add_to_cart_params.ajax_url,
					data,
					function (response) {
						if (!response) {
							return;
						}

						if (response.error && response.product_url) {
							window.location = response.product_url;
							return;
						}

						// Redirect to cart option
						if (
							wc_add_to_cart_params.cart_redirect_after_add ===
							'yes'
						) {
							window.location = wc_add_to_cart_params.cart_url;
							return;
						}

						// Trigger event so themes can refresh other areas.
						$(document.body).trigger('added_to_cart', [
							response.fragments,
							response.cart_hash,
							$thisbutton,
						]);

						//Added after

						getWcFragmentsRefreshed();

						//Added after
					}
				);

				return false;
			}
			return true;
		}
	);

	jQuery(document).ready(function () {
		// console.log(variableProductHasEmptyAttribute());

		if (
			variableProductHasEmptyAttribute($('.variations select')) === true
		) {
			$('.button.product_type_variable.add_to_cart_button').attr(
				'disabled',
				'disabled'
			);
		} else {
			$('.button.product_type_variable.add_to_cart_button').removeAttr(
				'disabled'
			);
		}

		jQuery('.variations select').on('change', function (evt) {
			// console.log(variableProductHasEmptyAttribute());

			if (
				variableProductHasEmptyAttribute($('.variations select')) ===
				true
			) {
				$('.button.product_type_variable.add_to_cart_button').attr(
					'disabled',
					'disabled'
				);
			} else {
				$(
					'.button.product_type_variable.add_to_cart_button'
				).removeAttr('disabled');
			}
		});
	});
};

export default addToCartVariation;
